import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/utils";
import { SortIcon, type SortDir } from "@/components/shared/SortIcon";

export interface SortableHeaderProps
  extends Omit<ComponentPropsWithoutRef<"th">, "onClick" | "children"> {
  label: string;
  /** Er denne kolonnen den aktive sorteringen? */
  active: boolean;
  dir: SortDir;
  onToggle: () => void;
  align?: "left" | "center" | "right";
}

/**
 * Sorterbar kolonneoverskrift som kan nås med Tab og aktiveres med Enter/Space
 * (VIB-2534). Knappen inni <th> bærer klikkflaten; <th> bærer aria-sort.
 */
export function SortableHeader({
  label,
  active,
  dir,
  onToggle,
  align = "left",
  className,
  ...rest
}: SortableHeaderProps) {
  return (
    <th
      aria-sort={active ? (dir === "asc" ? "ascending" : "descending") : "none"}
      className={cn("font-medium text-muted-foreground select-none", className)}
      {...rest}
    >
      <button
        type="button"
        onClick={onToggle}
        className={cn(
          "inline-flex w-full items-center whitespace-nowrap rounded-sm hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary",
          align === "left" && "justify-start text-left",
          align === "center" && "justify-center text-center",
          align === "right" && "justify-end text-right",
        )}
      >
        {label}
        <SortIcon active={active} dir={dir} />
      </button>
    </th>
  );
}
